export const GENERIC_API_SOURCE = 'source' as const;
export const GENERIC_API_SERVICE = 'ApiService' as const;
